import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { environment } from 'src/environments/environment';
import { URLS_CONST } from 'src/app/shared/constants/url-constants';
import { SessionMgmtService } from '../session-mgmt/session-mgmt.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ManagersService {

  constructor( public _utilsService: UtilsService ,
    private _session:SessionMgmtService) {
      
    }
    getAccess(
      manager: any,
      handlers: {
        gotoProject: (accountId: string, projectId: string) => void,
        gotoDashboard: (accountId: string) => void,
        gotoAccounts: () => void,
       logoutUser?: () => void,
        setError: (msg: string) => void,
        setShowLoader?: (show: boolean) => void,
        setLoaderMessage?: (msg: string) => void,
      }
    ): void {
      if (!manager || !manager._id) return;
    
      const accessList = manager.manager_access;
      if (!accessList?.length) {
        handlers.setShowLoader?.(false);
        handlers.setError("You don't have access for any project, please contact the System Administrator");
        return;
      }
    
      const managerAccess = this.getManagerAccess(accessList);
      const projectId = manager.brand_detail?.brand_id;
    
      const verifiedAccessList = accessList.filter(
        a => a.is_verified && ('has_dashboard_access' in a ? a.has_dashboard_access : true)
      );
    
      const isSingleAccount = new Set(accessList.map(a => a.account_id)).size === 1;
    
      // Case: Exactly one access and not a super manager
      if (verifiedAccessList.length === 1 && verifiedAccessList[0].manager_type !== 3) {
        handlers.setLoaderMessage?.('Redirecting to project...');
        handlers.gotoProject(managerAccess.brandsWithAccount[0], projectId);
      }
      // Case: Exactly one verified access and is super manager
      else if (verifiedAccessList.length === 1 && verifiedAccessList[0].manager_type === 3) {
        handlers.setLoaderMessage?.('Redirecting to dashboard...');
        handlers.gotoDashboard(managerAccess.brandsWithAccount[0]);
      }
      // Case: More than one brand, single account
      else if (managerAccess.brandsWithAccount.length > 1 && isSingleAccount) {
        handlers.setLoaderMessage?.('Redirecting to Project list...');
        handlers.gotoDashboard(managerAccess.brandsWithAccount[0]);
      }
      // Case: Multiple brands, mix of with/without accounts
      else if (
        (managerAccess.brandsWithAccount.length > 0 && managerAccess.brandsWithoutAccount.length > 0) ||
        managerAccess.brandsWithAccount.length > 1
      ) {
        handlers.setLoaderMessage?.('Redirecting to accounts...');
        handlers.gotoAccounts();
      }
      // Case: Only one brand with account
      else if (managerAccess.brandsWithAccount.length === 1) {
        handlers.setLoaderMessage?.('Redirecting to dashboard...');
        handlers.gotoDashboard(managerAccess.brandsWithAccount[0]);
      }
      // Fallback
      else {
        handlers.setLoaderMessage?.('Redirecting to accounts...');
        handlers.gotoAccounts();
      }
    }
    
  
    private getManagerAccess(accessArray: any[]): { brandsWithAccount: string[]; brandsWithoutAccount: string[] } {
      const brandsWithAccount = accessArray.filter((a) => a.account_id).map((a) => a.account_id);
      const brandsWithoutAccount = accessArray.filter((a) => !a.account_id).map((a) => a.brand_id);
      return { brandsWithAccount, brandsWithoutAccount };
    }
  setAsDefaultAccess(data) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.setManagerDefaultAccess);
    const params: any = {}
    params[URLS_CONST.BRAND_ID] = data.project_id;
    params[URLS_CONST.GROUP_KEY] = data.group_key;
    params[URLS_CONST.GROUP_VALUE] = data.group_value;
    return this._utilsService.putAPICall(url, params, this._utilsService.setHeaderWithParams(''))
  }

  switchAccess(data) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.setCurrentLoggedInManager);
    const params: any = {}
    params[URLS_CONST.BRAND_ID] = data.project_id;
    params[URLS_CONST.SELECTED_ID] = data.project_id;
    params[URLS_CONST.GROUP_KEY] = data.group_key;
    params[URLS_CONST.MANAGER_TYPE] = data.manager_type;
    return this._utilsService.postAPICall(url, params, this._utilsService.setHeaderWithParams(''))
  }

  setCurrentLoggedInManager(accountId: string, projectId: string) {
  const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.setCurrentLoggedInManager);
  const access: any = this.getMangagerAccess(accountId, projectId)
  const groupKey = access.access
  const params: any = {
    selected_id: access.brand_id,
    manager_type: access.manager_type,
    brand_id: access.brand_id,
    group_key: access.group_key
  };

  return this._utilsService.postAPICall(url, params, this._utilsService.setHeaderWithParams(''))
}

getMangagerAccess(accountId: string, projectId: string) {
  let access = {}
  const managerAccess = _.get(Helpers, 'managerDetails.manager.manager_access', []);
  if (!_.isEmpty(managerAccess)) {
    let accesses = _.filter(managerAccess, { brand_id: projectId, account_id: accountId, is_verified: true, has_dashboard_access: true })
    if (!_.isEmpty(accesses)) {
      // to pick top access sorting is applied if default access is not set.
      accesses = _.orderBy(accesses,['group_key'],['asc']);
      access = _.find(accesses, { is_default_access: true });
      if (access == undefined) {
        access = accesses[0];
      }
    } else {
      // const accesses = _.filter(managerAccess, {account_id: accountId, is_verified: true, has_dashboard_access: true })
      // if (!_.isEmpty(accesses)) {
      //   access = accesses[0];
      // }
      // API will set the manager type, if account level access - set as type 3 
      access = { "manager_type": 2, "brand_id": projectId, "selected_id": projectId, "group_key": null };
    }
  }
  return access
}

}
